import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const AddVideoTutorialCategorySlice = createSlice({
    name: "AddVideoTutorialCategorySlice",
    initialState: {} as IReduxState<any>,
    reducers: {
        addVideoTutorialCategory: (state, action) => {
            state.isLoading = true;
        },
        successaddVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureaddVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearAddVideoTutorialCategoryResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    addVideoTutorialCategory,
    successaddVideoTutorialCategory,
    failureaddVideoTutorialCategory,
    clearAddVideoTutorialCategoryResponse,
} = AddVideoTutorialCategorySlice.actions;

export default AddVideoTutorialCategorySlice.reducer;
